export function plainObjectsId(data) {
  const result = {};

  for (const [key, value] of Object.entries(data)) {
    if (!value) result[key] = value;
    else if (isListWithIdObjects(value)) result[key] = value.map(el => el.id);
    else if (value.hasOwnProperty('id')) result[key] = value.id;
    else result[key] = value;
  }

  return result;
}

export function isListWithIdObjects(list) {
  const isArray = Array.isArray(list) && list.length;
  if (!isArray) return false;

  return list[0].hasOwnProperty('id');
}
